import React from "react";

const TechBlog = () => {
    return(
        <React.Fragment>
            <div className='sticky top-0 z-50 mb-10 backdrop-blur'>
                <h1 className='font-bold uppercase text-sm'>Blogs</h1>
            </div>
        </React.Fragment>
    )
}

export default TechBlog;